<template lang="pug">
    ul(class="refinement-list bg-white text-sm lg:overflow-x-hidden lg:overflow-y-auto")
        li(
            v-for="refinement in refinements"
            class="refinement-value m-0 h-14 block pl-10 text-sm text-black border-b-2 border-gray-lighter"
        )
            div(:class="{ 'is-selected': refinement.isRefined }")
                label(class="flex h-14 cursor-pointer items-center")
                    input(
                        type="checkbox"
                        :checked="refinement.isRefined"
                        @change="toggleFacet(refinement)"
                        class="hidden"
                    )
                    div {{ refinement.display }}
</template>

<script>
import SearchComponent from '@/components/search/component'

export default {
    name: 'FilterList',
    extends: SearchComponent,
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        refinements() {
            const refinements = this.$searchContext.state.refinements[this.data.facet] || []
            return refinements.filter(({ isValid }) => isValid)
        },
    },
    methods: {
        toggleFacet(refinement) {
            const { value, isRefined } = refinement

            if (isRefined) this.$searchContext.removeRefinements(this.data.facet, value)
            else this.$searchContext.addRefinements(this.data.facet, value)

            const { mod } = this.$route.query

            const routeObj = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...(mod && { mod }),
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(routeObj)
        },
    },
}
</script>

<style lang="stylus" scoped>
.refinement-value

    label
        &:before
            content ''
            width 20px
            height 20px
            border-radius 3px
            border 2px solid theme('colors.gray.dark')
            margin-right 10px
            flex 0 0 auto

    .is-selected
        label
            &:before
                background-color theme('colors.action.DEFAULT')
                border-color theme('colors.action.DEFAULT')
                background-image url('~@/assets/common/checkmarkThick.svg')
                background-size 12px
                background-repeat no-repeat
                background-position center
</style>
